var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"login-modal","hide-footer":"","hide-header":"","no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","size":"xl"}},[_c('Login',{attrs:{"modal":true},on:{"success":_vm.onSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }